var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('z-tab',{staticClass:"z-tab-item",attrs:{"icon":_vm.icon,"action":_vm.clickHandler,"is-active":_vm.isActive,"disabled":_vm.disabled,"remove-indicator-styles":_vm.removeIndicatorStyles,"border-active-color":_vm.borderActiveColor}},[_vm._t("default",null,{"isActive":_vm.isActive})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }